import React, { ComponentType, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { currentUser } from 'redux/session/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import OrganisationProfileForm from './components/profileForm';
import { withFormik } from 'formik';
import {
  phoneNumberFormatter,
  OrganisationProfileSchema
} from 'utilities/validation';
import { OrganisationProfileDataTypes } from 'types';
import { updateOrgProfileStart } from 'redux/member/action';

interface InitialFormValuesProps {
  contactName: string;
  contactEmail: string;
  contactPhoneNumber: string;
  contactEmergencyPhone: string;
  contactUrl: string;
}

const OrganisationProfile: React.FC<RouteComponentProps<{}, any, any>> = () => {
  const dispatch = useDispatch();
  const user: any = useSelector(currentUser);
  const [organisationId, setOrganisationId] = useState<any>();
  const [formValues, setFormValues] = useState<OrganisationProfileDataTypes>({
    contactName: '',
    contactEmail: '',
    contactPhoneNumber: '',
    contactEmergencyPhone: '',
    contactUrl: ''
  });

  useEffect(() => {
    if (user) {
      const { organisationId, Organisation } = user;

      const {
        contactName,
        contactEmail,
        contactPhoneNumber,
        contactEmergencyPhone,
        contactUrl
      } = Organisation;

      // DEFAULT regionCode: 'AU'
      const cpNumber =
        contactPhoneNumber &&
        phoneNumberFormatter({
          phoneNumber: contactPhoneNumber
        }).getNationalNumberFormat();
      const cePhone =
        contactEmergencyPhone &&
        phoneNumberFormatter({
          phoneNumber: contactEmergencyPhone
        }).getNationalNumberFormat();
      setOrganisationId(organisationId);
      setFormValues({
        contactName,
        contactEmail,
        contactPhoneNumber: cpNumber,
        contactEmergencyPhone: cePhone,
        contactUrl
      });
    }
  }, [user]);

  const formatUrl = (values: any) => {
    if (!values.startsWith('http')) {
      return `http://${values}`;
    }
    return values;
  };

  const OrganisationProfileFormComp: ComponentType<any> = withFormik<
    InitialFormValuesProps,
    OrganisationProfileDataTypes
  >({
    validationSchema: OrganisationProfileSchema,
    mapPropsToValues: () => ({
      contactName: formValues?.contactName || '',
      contactEmail: formValues?.contactEmail || '',
      contactPhoneNumber: formValues?.contactPhoneNumber || '',
      contactEmergencyPhone: formValues?.contactEmergencyPhone || '',
      contactUrl: formValues?.contactUrl || ''
    }),
    handleSubmit: (values: OrganisationProfileDataTypes) => {
      const {
        contactName,
        contactEmail,
        contactPhoneNumber,
        contactEmergencyPhone,
        contactUrl
      } = values;
      const payload: OrganisationProfileDataTypes = {
        contactName,
        contactEmail,
        contactPhoneNumber,
        contactEmergencyPhone,
        contactUrl: formatUrl(contactUrl)
      };
      const params = { organisationId, payload };
      setFormValues(payload);
      dispatch(updateOrgProfileStart(params));
    },
    displayName: 'RegConfirmationForm'
  })(OrganisationProfileForm);

  return (
    <div id="organisation-profile" data-testid="organisation-profile">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="Contact Details"
        pageDescription="Keep these contact details up to date so enquirers can contact you about your assets"
        enableHeaderGlobalBar={true}
      >
        <div className="organisation-profile--body">
          <OrganisationProfileFormComp displayName="OrganisationProfileForm" />
        </div>
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};
OrganisationProfile.displayName = 'OrganisationProfileModule';

export default OrganisationProfile;
